{
  "version": 1,
  "asset_id": "6f9a8b4a-f917-452b-9f5b-67bd0ee77789",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6f9a8b4a-f917-452b-9f5b-67bd0ee77789/scar-tissue-crura-esophagus-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6f9a8b4a-f917-452b-9f5b-67bd0ee77789/scar-tissue-crura-esophagus-en-800.webp",
  "original_filename": "scar-tissue-crura-esophagus-en-800.webp",
  "size": 86914,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:02Z"
}
